import React, { useCallback } from 'react'
import MultiSelect from '../../common/MultiSelect.tsx'
import type { VoiceFilters } from '../../../features/voice/domain/models/voice-filters.ts'
import type { VoiceParameters } from '../../../features/voice/domain/models/voice-parameters.ts'

interface VoiceBoxListFiltersProps {
  setFilters: (filters: (prevFilters: VoiceFilters) => VoiceFilters) => void
  parameters: VoiceParameters | undefined
  filters: VoiceFilters
}

const VoiceBoxListFilters: React.FC<VoiceBoxListFiltersProps> = ({
  setFilters,
  parameters,
  filters,
}) => {
  const handleFilterChange = useCallback(
    (newFilter: VoiceFilters) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        ...newFilter,
      }))
    },
    [setFilters]
  )

  return (
    <div className="inline-flex w-full gap-2 bg-zinc-900">
      <MultiSelect
        options={parameters?.languages}
        onChange={(selected) => handleFilterChange({ languages: selected })}
        filterNameKey={'ls_filter_buttons_languages'}
        hasSelectAll
        initialSelected={filters.languages}
      />

      <MultiSelect
        options={parameters?.accents}
        onChange={(selected) => handleFilterChange({ accents: selected })}
        filterNameKey={'ls_filter_buttons_accents'}
        hasSelectAll
        initialSelected={filters.accents}
      />

      <MultiSelect
        options={parameters?.tags}
        onChange={(selected) => handleFilterChange({ tags: selected })}
        filterNameKey={'ls_filter_buttons_tags'}
        hasSelectAll
        initialSelected={filters.tags}
      />
    </div>
  )
}

export default VoiceBoxListFilters
